import React from 'react';
import { Check } from 'lucide-react';
interface ColorSelectorProps {
  selectedColor: string;
  onSelect: (color: string) => void;
}
export const ColorSelector: React.FC<ColorSelectorProps> = ({
  selectedColor,
  onSelect
}) => {
  const colors = [{
    id: 'antraciet',
    name: 'Antraciet',
    code: 'RAL 7016',
    hex: '#293133'
  }, {
    id: 'gitzwart',
    name: 'Gitzwart',
    code: 'RAL 9005',
    hex: '#0A0A0A'
  }, {
    id: 'metallic-grijs',
    name: 'Metallic grijs',
    code: 'RAL 9007',
    hex: '#8F8F8F'
  }, {
    id: 'verkeerswit',
    name: 'Verkeerswit',
    code: 'RAL 9016',
    hex: '#F1F1F1'
  }];
  return <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-10" data-id="element-717">
      {colors.map(color => <div key={color.id} onClick={() => onSelect(color.id)} className={`p-4 rounded-lg cursor-pointer transition-all duration-300 flex flex-col items-center text-center ${selectedColor === color.id ? 'bg-white/20 transform scale-[1.02] shadow-lg' : 'bg-white/10 hover:bg-white/15'}`} data-id="element-718">
          <div className={`w-16 h-16 rounded-full mb-3 border-2 ${selectedColor === color.id ? 'border-[#CDA735]' : 'border-transparent'}`} style={{
        backgroundColor: color.hex
      }} data-id="element-719">
            {selectedColor === color.id && <div className="w-full h-full flex items-center justify-center" data-id="element-720">
                <div className="w-6 h-6 rounded-full bg-[#CDA735] flex items-center justify-center" data-id="element-721">
                  <Check className="h-4 w-4 text-white" data-id="element-722" />
                </div>
              </div>}
          </div>
          <h3 className="text-white font-medium" data-id="element-723">{color.name}</h3>
          <p className="text-white/70 text-sm" data-id="element-724">{color.code}</p>
        </div>)}
    </div>;
};